import { PageTitle } from '~/components/common';
import { PageWrapper } from '~/components/layout';
import { ReceiveStatus3PLContent, ReceiveStatusDefaultContent } from '~/components/receive';

import { useToggle } from '~/hooks/common';
import { useUserInfoStore } from '~/store';

import { BREAD_CRUMB, PATH } from '~/constants';

/**
 * [입고관리 > 입고현황] 페이지 컴포넌트
 */
const ReceiveStatusPage = () => {
  const hasPermission = useUserInfoStore((state) => state.hasPermission);
  const hasPermission3PL = hasPermission([{ ownerType: '3PL' }]);

  const { isToggle: isFilterOpen, handleToggle: handleFilterToggle } = useToggle({ initialState: true });

  return (
    <PageWrapper>
      <PageTitle
        title="입고 현황"
        breadcrumbs={BREAD_CRUMB[PATH.RECEIVE_STATUS]}
        handleFilterToggle={handleFilterToggle}
      />
      {hasPermission3PL ? (
        <ReceiveStatus3PLContent isFilterOpen={isFilterOpen} />
      ) : (
        <ReceiveStatusDefaultContent isFilterOpen={isFilterOpen} />
      )}
    </PageWrapper>
  );
};

export default ReceiveStatusPage;
